<template>
  <div class="banner">
    <div
      style="position: relative; display: inline-block; width: 100%"
      @mouseenter="showBtn = true"
      @mouseleave="showBtn = false"
    >
      <img
        v-if="type === 'tall' && !videoLoaded"
        :src="require('@/assets/first/placeholder.png')"
        alt="视频占位图"
        class="tall"
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          max-width: 1900px;
          min-width: 1500px;
          z-index: 1;
        "
      />
      <video
        ref="promoVideo"
        class="tall"
        v-if="type === 'tall'"
        src="/videos/promotionalVideo.mp4"
        autoplay
        loop
        muted
        playsinline
        :style="'max-width: 1900px; min-width: 1500px; object-fit: contain; width: 100%; background: #000;'"
        @click="togglePlay"
        @canplay="onVideoLoaded"
      ></video>
      <!-- 音量按钮 -->
      <button
        v-if="type === 'tall'"
        class="sound-toggle-btn"
        @click.stop="toggleMute"
        :aria-label="isMuted ? '开启声音' : '关闭声音'"
        :style="'position: absolute; top: 24px; right: 24px; z-index: 3; background: rgba(0,0,0,0.4); border: none; border-radius: 50%; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; cursor: pointer;'"
      >
        <!-- 音符图标 SVG -->
        <svg
          v-if="isMuted"
          width="28"
          height="28"
          viewBox="0 0 32 32"
          fill="none"
        >
          <circle cx="16" cy="16" r="16" fill="#22292f" fill-opacity="0.7" />
          <path
            d="M20 9v10.563a3.5 3.5 0 1 1-2-3.163V11.5h-2V9h4z"
            fill="#fff"
          />
          <path d="M24 12l-4 4" stroke="#fff" stroke-width="2" />
        </svg>
        <svg v-else width="28" height="28" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="16" fill="#22292f" fill-opacity="0.7" />
          <path
            d="M20 9v10.563a3.5 3.5 0 1 1-2-3.163V11.5h-2V9h4z"
            fill="#fff"
          />
        </svg>
      </button>
      <button
        v-if="type === 'tall' && showBtn"
        class="custom-video-btn"
        :class="{ paused: isPaused }"
        @click.stop="togglePlay"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          background: rgba(0, 0, 0, 0.5);
          border: none;
          border-radius: 50%;
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        "
      >
        <svg v-if="isPaused" width="32" height="32" viewBox="0 0 32 32">
          <polygon fill="#fff" points="12,8 24,16 12,24" />
        </svg>
        <svg v-else width="32" height="32" viewBox="0 0 32 32">
          <rect x="9" y="8" width="5" height="16" fill="#fff" />
          <rect x="18" y="8" width="5" height="16" fill="#fff" />
        </svg>
      </button>
    </div>
    <!-- <img
      class="middle"
      v-else-if="type === 'middle'"
      src="../assets/banner-middle.webp"
      alt=""
    />
    <img
      class="short"
      v-else-if="type === 'short'"
      src="../assets/banner-short.webp"
      alt=""
    />
    <img
      class="short"
      v-else-if="type === 'short2'"
      src="../assets/banner-short2.webp"
      alt=""
    />
    <img
      class="short"
      v-else-if="type === 'short3'"
      src="../assets/banner-short2.webp"
      alt=""
    /> -->
  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
    type: {
      type: String,
      default() {
        return "tall";
      },
    },
  },
  data() {
    return {
      isPaused: false,
      showBtn: false,
      videoLoaded: false,
      isMuted: true,
      hasUnmuted: false,
    };
  },
  methods: {
    togglePlay() {
      const video = this.$refs.promoVideo;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.isPaused = false;
      } else {
        video.pause();
        this.isPaused = true;
      }
    },
    onVideoLoaded() {
      this.videoLoaded = true;
    },
    toggleMute() {
      const video = this.$refs.promoVideo;
      if (!video) return;
      if (this.isMuted && !this.hasUnmuted) {
        video.muted = false;
        this.isMuted = false;
        this.hasUnmuted = true;
        video.play();
      } else {
        video.muted = !video.muted;
        this.isMuted = video.muted;
      }
    },
  },
  mounted() {
    const video = this.$refs.promoVideo;
    if (video) {
      video.muted = true;
      this.isMuted = true;
      video.addEventListener("pause", () => {
        this.isPaused = true;
      });
      video.addEventListener("play", () => {
        this.isPaused = false;
      });
    }
  },
};
</script>

<style lang="less" scoped>
.banner {
  .tall {
    width: 100%;
    height: 1070px;
  }
  .short {
    width: 100%;
    height: 280px;
  }
  .middle {
    width: 100%;
    height: 429px;
  }
}
.custom-video-btn {
  transition: background 0.2s;
}
.custom-video-btn:hover {
  background: rgba(0, 0, 0, 0.7);
}
.sound-toggle-btn {
  transition: background 0.2s;
}
.sound-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.7) !important;
}
</style>
